import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const ComentarioFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='COMENTARIO' htmlFor='textarea-comentario' md={2} alignRightAt='md' />
      <Col md={10}>
        <Field name='comentario'>
          {({ field }) => (
            <Form.TextArea
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              rows='2'
              id='textarea-comentario'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ComentarioFormGroup)
